import Link from "next/link";
import { salesRoutes } from "@nju/routes";
import { A, BlockText, Button, ButtonsWrapper, Separator } from "@nju/ui";

interface IRegistrationConfirmCreateOrderProps {
  handleCreateOrder: () => void;
}

export function RegistrationConfirmCreateOrder({
  handleCreateOrder,
}: IRegistrationConfirmCreateOrderProps) {
  return (
    <>
      <BlockText align="left" size={{ "@onlyMobile": "m", "@fromTablet": "l" }}>
        Właśnie anulujemy zamówienie klienta na nju światłowód, gdyż klient go
        nie dokończył. Przejdź dalej, by kontynuować swoje zamówienie. W razie
        potrzeby spróbuj ponownie za chwilę.
      </BlockText>
      <Separator size="m" tone="invisible" />
      <ButtonsWrapper>
        <Link href={salesRoutes.wybierzOferte.get()} passHref={true}>
          <A size={{ "@onlyMobile": "s" }} variant="secondary">
            anuluj
          </A>
        </Link>
        <Button onPress={handleCreateOrder} size={{ "@onlyMobile": "s" }}>
          dalej
        </Button>
      </ButtonsWrapper>
    </>
  );
}
